import React from 'react';
import { HookProvider } from 'react-gldn-kit';
import {
  useTransportControllers,
  useCurrencies,
  useCountryInfo,
} from 'react-render-hooks';

type Props = {
  children: React.ReactElement;
};

export const LogicModalProvider = ({ children }: Props) => (
  <HookProvider
    value={{
      useTransportControllers,
      useCurrencies,
      useCountryInfo,
    }}
  >
    {children}
  </HookProvider>
);
